import { selectSuggestionsState } from '../store/suggestionsSlice';
import { SuggestionsProps } from '../service/suggestions.interface';
import { useCreateSuggestionsMutation } from '../service/ai';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';
import { useApiSuccessNotification } from '../../../../../hooks/useApiSuccessNotification';

export const useSuggestions = () => {
    const { tooltips, status } = useAppSelector(selectSuggestionsState);
    const current = useAppSelector(selectShopCurrent);

    const [createSuggestion, { isSuccess }] = useCreateSuggestionsMutation();

    useApiSuccessNotification(isSuccess, {
        message: 'Вопросы успешно сохранены',
    });

    const submit = async (values: SuggestionsProps[]) => {
        const filtered = values.filter(
            suggestion =>
                suggestion.title.trim() !== '' && suggestion.text.trim() !== ''
        );

        const payload = {
            id: +current.id,
            tooltips: filtered,
        };

        await createSuggestion(payload);
    };

    return { tooltips, status, submit };
};
